import { css } from 'emotion';

import { Orientation } from '../styles';

export const formControl = (orientation: Orientation) => css`
  width: ${orientation === Orientation.VERTICAL ? '100%' : 'auto'};
  display: ${orientation === Orientation.VERTICAL ? 'block' : 'inline-flex'};

  && label {
    margin-bottom: 10px;
    position: relative;
    transform: none;

    & + * {
      min-width: 100%;
    }
  }
`;
